import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Star } from 'lucide-react';
import { Button } from '../ui/Button';
import { trackPixel } from '../../lib/metaPixel';
const CHECKOUT_URL = 'https://tarotprofesional.impultienda.ar/checkout';
function handleCheckoutClick() {
  // Señal de conversión hacia el pixel de Meta al iniciar la compra.
  trackPixel('InitiateCheckout', {
    content_name: 'Formación Profesional en Tarot',
    currency: 'ARS'
  });
}
const includes = ['12 Tomos Profesionales', 'Bono 1: Diccionario Profesional de las 78 Cartas', 'Bono 2: 50 Tiradas Profesionales', 'Bono 3: Cuaderno de Prácticas del Tarotista', 'Manual Profesional de Interpretación del Tarot', 'Tarot Evolutivo y Arquetipos Profundos', 'Certificado Digital', 'Acceso inmediato', 'Acceso de por vida'];
export function Pricing() {
  return <section id="pricing" className="py-12 md:py-24 relative z-10 bg-mystic-900/80 scroll-mt-4" data-id="element-182">
      <div className="container mx-auto px-4" data-id="element-183">
        <motion.div initial={{
        y: 20
      }} whileInView={{
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6 md:mb-14" data-id="element-184">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-white mb-3 md:mb-4" data-id="element-185">
            Accedé a la formación completa
          </h2>
          <div className="w-20 md:w-24 h-1 bg-gold mx-auto rounded-full" data-id="element-186"></div>
        </motion.div>

        <div className="max-w-lg mx-auto" data-id="element-187">
          <motion.div initial={{
          y: 20
        }} whileInView={{
          y: 0
        }} viewport={{
          once: true
        }} className="bg-mystic-800 border-2 border-gold rounded-2xl p-5 pt-7 md:p-10 flex flex-col relative shadow-gold-lg" data-id="element-188">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gold text-mystic-900 px-3 md:px-4 py-1 rounded-full text-xs md:text-sm font-bold flex items-center gap-1 shadow-lg whitespace-nowrap" data-id="element-189">
              <Star size={14} fill="currentColor" data-id="element-190" /> FORMACIÓN COMPLETA
            </div>

            <h3 className="font-serif text-2xl md:text-4xl font-bold text-gold mb-1 md:mb-2 text-center" data-id="element-191">
              Formación Profesional en Tarot
            </h3>
            <p className="text-white/60 text-center text-sm md:text-base mb-4 md:mb-6" data-id="element-192">
              Todo el material para dominar el Tarot desde cero hasta nivel
              profesional.
            </p>
            <div className="w-full h-px bg-gold/20 mb-4 md:mb-6" data-id="element-193"></div>

            <div className="text-xs md:text-sm font-bold text-white/50 uppercase tracking-wider mb-3 md:mb-4" data-id="element-194">
              Incluye
            </div>
            <ul className="space-y-2 md:space-y-4 mb-6 md:mb-8" data-id="element-195">
              {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-196">
                  <CheckCircle2 size={18} className="text-gold flex-shrink-0 mt-0.5" data-id="element-197" />
                  <span className="text-white/90 text-sm md:text-base leading-snug" data-id="element-198">
                    {item}
                  </span>
                </li>)}
            </ul>

            <Button href={CHECKOUT_URL} variant="primary" size="lg" onClick={handleCheckoutClick} className="w-full text-base md:text-lg py-4 md:py-5" data-id="element-199">
              QUIERO ACCEDER AHORA
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}